export default __webpack_public_path__ + "static/media/login.6d841838.jpg";